export default __webpack_public_path__ + "static/media/DPI.61c23521.png";